<template>
    <div id="app" :class="layoutClasses">
        <AppHeader />
        <notifications position="center right" classes="kkk-notification" />
        <router-view :key="$route.fullPath" />
        <AppFooter />
        <WBFeeback :showModal="showFeebackModal" @on-close="modalOnClose" />
        <collection-modal v-if="modalMerkliste" :content="content" @showCreateModal="showCreateModal"
            @closeModal="modalMerkliste = false, content = null" />
        <create-collection-modal v-if="modalCreatePlan" :content="content"
            @closeModal="modalCreatePlan = false, content = null" />
        <CookieBanner />
        <BackToTop />

        <a href="/system/1811920" class="gebaerdensprache-icon" aria-label="Gebärdensprache in der Wolfsburger Lupe"
            title="Gebärdensprache in der Wolfsburger Lupe">
            <img src="/assets/dgs_symbol_black.png" alt="Gebärdensprache">
        </a>

    </div>
</template>

<script>
import { bus } from './main';
import { isMobile } from 'mobile-device-detect';
import { languageChangeMixin } from '@/mixins/languageChangeMixin';

export default {
    name: 'App',
    components: {
        AppHeader: () => import('@/components/layout/AppHeader.vue'),
        AppFooter: () => import('@/components/layout/AppFooter.vue'),
        WBFeeback: () => import('@/components/modals/WBFeedback.vue'),
        CookieBanner: () => import('@/components/modals/CookieBanner.vue'),
        BackToTop: () => import('@/components/controls/BackToTop.vue'),
        CollectionModal: () => import('@/components/modals/addContentToCollection/collection.vue'),
        CreateCollectionModal: () => import('@/components/modals/createCollection'),
    },
    mixins: [languageChangeMixin],
    data: () => ({
        showFeebackModal: false,
        modalMerkliste: false,
        modalCreatePlan: false,
        isItMobile: isMobile,
    }),
    created() {
        bus.$on('show-merkliste-modal', (elem) => {
            if (elem !== null && elem.hasOwnProperty("content")) {
                this.content = elem.content;
            }
            this.modalMerkliste = true
        })

        bus.$on('show-create-plan-modal', () => {
            this.modalCreatePlan = true
        })
        bus.$on('show-feedback-modal', () => {
            this.showFeebackModal = true;
        });
    },
    computed: {
        layoutClasses() {
            var route = "";
            const routeName = this.$route.name;
            route = this.camelCaseToHyphen(routeName) + " " + route;
            if (this.isItMobile) {
                route = route + " is-mobile";
            }
            return route;
        },
    },
    beforeCreate() {
        /*load all the data needed to run this app*/
        this.$store.dispatch('loadCollections', true);
    },
    methods: {
        camelCaseToHyphen(str) {
            if (str !== null) {
                return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
            }
            return str;
        },
        modalOnClose() {
            this.showFeebackModal = false;
        },
        showCreateModal() {
            this.modalMerkliste = false
            this.modalCreatePlan = true
        },
    }
}
</script>
<style lang="scss">
@import '@/scss/_variables.scss';

.gebaerdensprache-icon {
    position: fixed;
    bottom: 20px;
    left: 10px;
    z-index: 12000;
    width: 70px;
    height: 70px;
    background-color: #fff;
    border-radius: 20px;
    padding: 10px;
    border: 1px solid #000;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
    cursor: pointer;
    transition: all 0.3s ease;

    @media (max-width: 780px) {
        top: auto;
        bottom: 185px;
        left: auto;
        right: 10px;
        height: 48px;
        width: 48px;
        padding: 8px;
        border-radius: 10px;
    }

    &:hover {
        transform: scale(1.1);
    }

}

.vue-notification-group {
    z-index: 12000;
    margin-top: 20px;

    .vue-notification-wrapper {

        .kkk-notification {
            margin: 0px 10px 10px 10px;
            padding: 10px 30px;
            color: $primary;
            border: 1px solid black;
            box-shadow: 1px 2px 4px 0px #00000040;
            transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

            .notification-title {
                color: $secondary;
            }

            .notification-content {
                color: $primary;
            }

            &.error {
                border: 2px solid $secondary;
            }

        }
    }
}
</style>